import type { ReactNode } from 'react';
import { View } from 'react-native';

import type { PageBuilderLayout } from '@fhs/cms-groq-queries';
import { createMqStyles, tokens } from '@fhs/ui';

import type { ActionHandler } from '../types';
import { addActionSource } from '../utils/action';

import { LayoutFooter } from './footer';

type LayoutProps = {
  layout: Pick<PageBuilderLayout, 'footer' | 'internalName' | '_id'>;
  children: ReactNode;
  onAction: ActionHandler;
};

export function Layout(props: LayoutProps) {
  const mqStyles = useMqStyles();
  return (
    <View style={mqStyles.layout}>
      <View style={mqStyles.widgetContainer}>{props.children}</View>
      <LayoutFooter
        onAction={addActionSource(
          {
            widgetId: props.layout.internalName ?? props.layout._id,
            widgetType: 'layout-footer',
          },
          props.onAction
        )}
        legalLinks={props.layout.footer.legalLinks}
        legalText={props.layout.footer.legalText}
        linkGroups={props.layout.footer.linkGroups}
        socialLinks={props.layout.footer.socialLinks}
      />
    </View>
  );
}

const useMqStyles = createMqStyles({
  layout: {
    $base: {
      backgroundColor: tokens.colors.$white,
      flexGrow: 1,
    },
  },
  widgetContainer: {
    $base: {
      flexGrow: 1,
      gap: 24,
    },
    $gteDesktop: {
      gap: 32,
    },
  },
});
